<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <div v-if="!loading&&objectUrn" :style="{height:height+'px'}">
            <forge-vuer
                :getAccessToken="getToken"
                ref="forgevuer"
                @selection-changed-event="handleSelectionChange"
                @geometry-loaded-event="applySelection"
                @model-root-loaded-event="initialSetup"
                :urn="objectUrn"/>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import LoadingProgressBar from './../LoadingProgressBar'
import ForgeVuer from 'forge-vuer';

export default {
    props: {
        url: {type: String, default: null},
        height: {type: Number, default: 800},
        selectedItems: {type: Array, default: null},
        selectionColor: {type: String, default: null},
        whiteMode:{type:Boolean, default: false},
    },
    components: {LoadingProgressBar, ForgeVuer},
    computed: {

    },
    name: 'ForgeViewerWidget',
    watch: {
        selectedItems(){
            this.applySelection()
        }
    },
    data: function () {
        return {
            loading: true,
            timeout: null,
            objectUrn: null,
        }
    },
    mounted() {
        this.refresh()
    },
    methods: {
        debounce(callback, wait) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => callback(), wait);
        },
        refresh() {
            this.debounce(this.reloadViewer, 200);
        },
        handleSelectionChange(eventData){
            console.log(eventData)
            this.$emit('select', eventData)
        },
        initialSetup(){
            if (this.whiteMode){
                this.$refs.forgevuer.viewerService.Viewer3D.setBackgroundColor(255,255,255,255,255,255)
            } else {
                this.$refs.forgevuer.viewerService.Viewer3D.setBackgroundColor(66,66,66,66,66,66)
            }
        },
        applySelection(){
            if(this.selectedItems&&this.$refs.forgevuer){
                this.$refs.forgevuer.viewerService.Viewer3D.setSelectionColor(this.selectionColor)
                this.$refs.forgevuer.viewerService.Viewer3D.select(this.selectedItems)
                this.$refs.forgevuer.viewerService.Viewer3D.fitToView(this.selectedItems)
            }
        },
        async getToken(onSuccess) {
            axios.post(this.url.replace('public', 'sign').replace('mode=embed', 'oauth2=true'), {}, {overrideCarnotAuth:true})
                .then(response => {
                    onSuccess(response.data.accessToken, response.data.validitySeconds);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        async reloadViewer() {
            if (this.url && this.url !== "") {
                let me = this
                me.loading = true
                let urnResponse = await axios.get(this.url.replace('public', 'metadata').replace('mode=embed', ''),{overrideCarnotAuth:true})
                me.objectUrn=urnResponse.data.success.body.viewing.views.viewableUrn
                me.loading = false
            }
        }
    },

}

</script>

<style scoped>

</style>
